module.exports = __webpack_public_path__ + "static/media/doorman.f881e517.svg";